import api from "./api";

export const agencyRoleService = {
  getPermissionCatalog: async (token) => {
    const res = await api.get("/agency-roles/permissions", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || { permissions: [] };
  },

  getRoles: async (token) => {
    const res = await api.get("/agency-roles", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || { roles: [], total: 0 };
  },

  createRole: async (payload, token) => {
    const res = await api.post("/agency-roles", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || null;
  },

  updateRole: async (id, payload, token) => {
    const res = await api.put(`/agency-roles/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || null;
  },

  deleteRole: async (id, token) => {
    const res = await api.delete(`/agency-roles/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || null;
  },

  getRoleUsers: async (id, token) => {
    const res = await api.get(`/agency-roles/${id}/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || { users: [] };
  },

  getAssignableUsers: async (token) => {
    const res = await api.get("/agency-roles/assignable-users", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || { users: [] };
  },

  assignUsers: async (id, userIds, token) => {
    const res = await api.post(
      `/agency-roles/${id}/users`,
      { userIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data?.data || res.data || null;
  },

  removeUser: async (id, userId, token) => {
    const res = await api.delete(`/agency-roles/${id}/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data?.data || res.data || null;
  },
};

export default agencyRoleService;
